import React from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@mui/styles';
import { Button, Dialog, DialogActions } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningIcon from '@mui/icons-material/Warning';

import TableTabIcon from '@mui/icons-material/TableChart';
import DashboardTabIcon from '@mui/icons-material/Dashboard';
import LoaderNew from './LoaderNew';
import CommonStyles from './CommonStyles';

import { jelTypes } from '../constants';

const styles = {
  paper: {
    minWidth: '345px',
    maxWidth: '500px',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
  },
  closeModalIcon: {
    top: '10px',
    fontSize: 20,
    right: '10px',
    color: '#C4C4C4',
    transition: '.2s',
    position: 'absolute',
    '&:hover': {
      color: '#4E4C4C',
      cursor: 'pointer',
      transition: '.2s',
    },
  },
  content: {
    display: 'flex',
    padding: '20px 40px',
    alignItems: 'center',
    boxSizing: 'border-box',
    flexDirection: 'column',
  },
  contentIcon: {
    fontSize: 18,
    color: '#E91818',
    marginBottom: 10,
  },
  warningIcon: {
    fontSize: 18,
    color: '#EECD3C',
    marginBottom: 10,
  },
  contentText: {
    fontSize: 14,
    marginRight: 5,
    color: '#4E4C4C',
  },
  causeDataLossText: {
    display: 'flex',
    color: '#4E4C4C',
    marginBottom: '10px',
    alignItems: 'center',
  },
  causeDataLossBoldText: {
    display: 'flex',
    color: '#4E4C4C',
    fontWeight: 600,
    marginBottom: '10px',
    alignItems: 'center',
  },
  contentBoldText: {
    fontSize: 14,
    fontWeight: 600,
    color: '#4E4C4C',
  },
  dialogActions: {
    //background: '#F1F1F6',
    justifyContent: 'center',
  },
  // actionBtn: {
  //   fontSize: 14,
  //   color: '#4c4c4c',
  //   minHeight: '32px',
  //   padding: '1px 20px',
  //   margin: '0 20px 0 0',
  //   borderRadius: '20px',
  //   textTransform: 'none',
  //   background: '#ffff',
  //   minWidth: '60px',
  //   boxShadow: 'none',
  //   border: '1px solid #E3E1F0',
  //   '&:hover': {
  //     boxShadow: 'none',
  //     backgroundColor: '#ffff',
  //     border: '1px solid #D9D8ED',
  //   },
  // },
  actionBtnAccept: {
    color: '#E91818',
    '&:hover': {
    },
  },
  ...CommonStyles,
};

export default connect((state) => ({ jels: state.jels, accounts_tbox: state.meta.accounts_tbox }))(
  withStyles(styles)(({ jels, accounts_tbox, onClose, classes, modalData, acceptHandler, loadingConfirm }) => {

    let topBorderColor = modalData.warning ? '#EECD3C' : '#E91818';

    return (
      <Dialog
        maxWidth={false}
        onClose={onClose}
        open={modalData.open}
        className={classes.modal}
        aria-labelledby="simple-dialog-title"
        classes={{
          paper: classes.paper,
        }}
      >
        <div style={{ height: '3px', background: topBorderColor }}></div>

        <CloseIcon className={classes.closeModalIcon} onClick={() => onClose()} />

        <div className={classes.content}>
          {modalData.warning ?
            <WarningIcon className={classes.warningIcon} />
            :
            <DeleteIcon className={classes.contentIcon} />
          }

          <div className={classes.textCenter}>
            <span className={classes.contentText}>{modalData.contentText}</span>
            {modalData.contentBoldText && <span className={classes.contentBoldText}>{modalData.contentBoldText}</span>}
          </div>
        </div>

        <div style={{ background: '#F1F1F6', paddingLeft: '40px' }}>
          {modalData.causeDataLoss && !!modalData.causeDataLoss.length &&
            <React.Fragment>
              <div className={classes.causeDataLossBoldText}>
                <span>It will cause the loss of data:</span>
              </div>

              {modalData.causeDataLoss.map(entityData =>
                <div key={entityData.entityName}
                  className={classes.causeDataLossText}
                >
                  <span>- {entityData.entityCount} {entityData.entityName}</span>
                </div>
              )}
            </React.Fragment>
          }
          {modalData.isInAnotherJel && !!modalData.isInAnotherJel.length &&
            <React.Fragment>

              <div style={{ paddingTop: '10px' }} className={classes.causeDataLossText}>
                <span>This view used in:</span>
              </div>

              {modalData.isInAnotherJel.map((jelObj) => {
                const jel = jels.jelData[jelObj.id];

                const dashboardJelTitle =
                  jelObj.type === jelTypes.dashboard && accounts_tbox.nodes[jel.acc_concept]
                    ? accounts_tbox.nodes[jel.acc_concept].title
                    : 'Deleted concept';

                return (
                  <div key={jelObj.id} className={classes.causeDataLossText}
                  >
                    {jelObj.type === jelTypes.dashboard ? (
                      <DashboardTabIcon
                        style={{
                          color: '#8F24B7',
                          fontSize: 16,
                          marginRight: '10px',
                        }}
                      />
                    ) : jelObj.type === jelTypes.form ? (
                      <img
                        src="/images/ui-edit-frm.svg"
                        alt="ui-edit-frm"
                        style={{
                          width: '12px',
                          height: '12px',
                          marginRight: '10px',
                        }}
                      />
                    ) : jelObj.type === jelTypes.table ? (
                      <TableTabIcon
                        style={{
                          color: '#DE3939',
                          fontSize: 16,
                          marginRight: '10px',
                        }}
                      />
                    ) : null}

                    <span>{jelObj.type === jelTypes.dashboard ? dashboardJelTitle : jel.title}</span>
                  </div>
                );
              })}
            </React.Fragment>
          }
        </div>

        <DialogActions className={classes.dialogActions}>
          <Button className={classes.actionBtn} onClick={() => onClose()}>
            No, Cancel
          </Button>

          <Button
            className={`${classes.actionBtn} ${classes.actionBtnAccept}`}
            onClick={() => acceptHandler()}
          >
            {loadingConfirm ? <LoaderNew color='white'/> : modalData.warning ? 'Yes, Save' : 'Yes, Delete'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  })
);
